import { createContext } from "react";

type ChatFullscreenContextType = {
  setFullscreen: (value: boolean) => void;
};

const ChatFullscreenContext = createContext<ChatFullscreenContextType>({
  setFullscreen: () => {},
});

export default ChatFullscreenContext;
